import i18n from 'src/features/i18n';
import toast from 'src/utils/toast';
import consts from 'src/utils/consts';
import { l } from 'src/utils/helper';

let excludeConst = [];

function handleLoginErrMsg(ldapStatus) {
  switch (ldapStatus) {
    case 'blocked':
      return 'T_ACCOUNT_IS_BLOCKED';
    case 'disabled':
      return 'T_ACCOUNT_IS_DISABLED';
    case 'invalid credentials':
    // совпадает с обработкой default, вынесен в отдельный case
    // для понимания обработки именно 'invalid credentials'
      return 'T_LOGIN_ERROR';
    case 'access deny':
      return 'T_ACCESS_DENIED';
    default: // как правило соответствует null
      return 'T_LOGIN_ERROR';
  }
}

function handleOutbaundActivityCreateErr(message, i18nKey, payload) {
  if (payload?.operator_name || payload?.operator_surname) {
    const errMessage = i18n.t(message, [payload.operator_surname, payload.operator_name]);
    toast.error({ msg: errMessage });
    l.error(`VISIBLE_EXCEPTION: ${errMessage}`);
  } else {
    toast.error({ msg: message ? i18n.t(message) : i18n.t(i18nKey) });
    l.error(`VISIBLE_EXCEPTION: ${message ? i18n.t(message) : i18n.t(i18nKey)}`);
  }
}

const [SYSTEM_EXCEPTION, VISIBLE_EXCEPTION] = ['system_exception', 'visible_exception'];
const onHandle = (error, path, message, payload) => {
  let i18nKey = `T_RESPONSE_${error.code}`;
  switch (error.type) {
    case SYSTEM_EXCEPTION:
      l.error(`SYSTEM_EXCEPTION: date:${new Date().toLocaleTimeString()}|`
        + ` code=${error.code}, type=${error.type}, payload=${error.payload} |`
        + ` text=${i18n.t(i18nKey)}`);
      break;
    case VISIBLE_EXCEPTION:
      if (error.payload.length) {
        let errors = error.payload[0].desc;
        let nameField = error.payload[0].field;
        if (path && path.includes('ActivityNotification') && nameField === 'name') {
          errors = 'T_ACTIVITY_NOTIFICATION_NAME_ERROR';
        }
        nameField = nameField ? `T_${nameField.toUpperCase()}` : '';
        nameField = i18n.t(nameField).toLowerCase();
        const metaInf = error.payload[0].meta;
        const metaInfLoc = metaInf.map((item) => {
          const array = Array.isArray(item)
            ? item : item.toString().split(/\s*,\s*/).filter((str) => str !== '');
          return array.map((inner) => i18n.t(inner.toUpperCase()).toLowerCase());
        });
        const params = [nameField, ...metaInfLoc];
        toast.error({
          title: i18n.t(i18nKey),
          msg: i18n.t(errors, [...params]),
          duration: consts.TOAST_NOTIFICATION_DURATION,
        });
        l.error(`VISIBLE_EXCEPTION: ${i18n.t(i18nKey)} - ${i18n.t(errors, [...params])}`);
      } else if (path && path.includes('login') && error.code === 403) {
        i18nKey = handleLoginErrMsg(error.ldap_status);
        toast.error({ msg: i18n.t(i18nKey) });
        l.error(`VISIBLE_EXCEPTION: ${i18n.t(i18nKey)}`);
      } else {
        if (path === 'createOutboundActivity') {
          handleOutbaundActivityCreateErr(message, i18nKey, payload);
          return;
        }
        toast.error({ msg: message ? i18n.t(message) : i18n.t(i18nKey) });
        l.error(`VISIBLE_EXCEPTION: ${message ? i18n.t(message) : i18n.t(i18nKey)}`);
      }
      break;
    default:
      l.error(`date:${new Date().toLocaleTimeString()}| undefined type. error: ${JSON.stringify(error)}`);
      break;
  }
};

const interpolation = (error, fieldsName) => {
  const name = i18n.t(fieldsName[error.field] || '');
  let metaArr = [i18n.t(name)];
  if (error.meta.length) {
    metaArr = metaArr.concat(error.meta);
  }
  return {
    ...error,
    desc: i18n.t(error.desc, metaArr),
  };
};

const interpolationWord = (error, name = '', meta) => {
  let metaArr = [i18n.t(name)];
  if (meta && Array.isArray(meta)) {
    metaArr = metaArr.concat(meta);
  } else if (meta) {
    metaArr.push(meta);
  }
  return i18n.t(error, metaArr);
};

// Сервис обрабатывает ошибки согласно протоколу ./doc/error_protocol.md
export default {
  // метод исключает из стандартной обработки коды ошибок
  exclude(codes) {
    excludeConst = excludeConst.concat(codes);
    return excludeConst;
  },
  // очищает кэш исключенных кодов
  // TODO: подумать, нужен ли такой метод в публичном API сервиса
  clear() {
    excludeConst = [];
  },
  // TODO: подумать, может лучше в лог всегда ошибки писать
  handle(error, path, message, payload) {
    if (!excludeConst.includes(error.code)) {
      onHandle(error, path, message, payload);
    }
  },
  interpolation,
  interpolationWord,
};
